export default __webpack_public_path__ + "static/media/screenshot4.747dbd93.jpg";